import { useEffect } from 'react';
import { Box, Grid, Typography, Container, Paper } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const registerYourself = [
  {
    text: (
      <>
        Join world’s <br />
        largest <br></br>
        Proposed I Am <br></br>
        Peacekeeper <br></br>
        Movement
      </>
    ),

    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Learn & live <br></br>7 Human <br></br>
        Values
      </>
    ),

    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Earn 21% I Am <br></br>
        Peacekeeper <br></br>
        Incentive
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Experience <br></br>
        inner Peace
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Be part <br></br>
        of World <br></br>
        Peace
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Sell I Am <br></br>
        Peacekeeper <br></br>
        Gifts & earn <br></br>
        21%
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Feel <br></br>
        positive, <br></br>
        conquer <br></br>
        fears
      </>
    ),
    colorClass: "gradient-blue",
  },
];

const highlights = [
  {
    title: "Contribution",
    description: "Supported by voluntary contributions and community giving. ",
    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility",
    description: <>
      Any registered I Am Peacekeeper  member facing genuine hardship.
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal",
    description: "Provide timely and empathetic assistance through a transparent process.",
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach",
    description: <>
        Accessible to I Am Peacekeeper members across all continents.
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyItMatters = [
  <>
A safety net for those <br></br> who carry forward <br></br>Justice, Love & Peace. 
  </>,
  <>
  Responds to personal crises,  emergencies or unforeseen hardship.
  </>,

  <>
   Guided by empathy, <br></br> transparency and fairness.
  </>,
  <>
  Builds solidarity — I Am Peacekeeper stands with one another.
  </>,
  <>
   Encourages collective <br></br>responsibility for <br></br> the well-being of every member.
  </>,
  <>
   Strengthens trust, <br></br> belonging and <br></br>community resilience.
  </>,
  <>
  Embodies the 7 <br></br> Human  Values: Truth, Gratitude, 
  Forgiveness, Love, Humility,  Giving, Patience.
  </>
];

const howITWorks = [
  <>
    An  I Am Peacekeeper <br></br> in need submits <br></br> their concern confidentially.
  </>,
  <>
   Each case is referred <br></br> to the Welfare Committee <br></br> for consideration.
  </>,

  <>
  The Committee  reviews <br></br> requests with fairness <br></br> and due diligence.
  </>,
  <>
   Every decision is guided <br></br> by empathy and compassion.
  </>,
  <>
  Priority is given to urgent <br></br> humanitarian needs.
  </>,
  <>
  Collective decision-making <br></br> ensures no bias <br></br> or favouritism.
  </>,
  <>
  Disbursement of funds is made <br></br> only through <br></br> official channels.
  </>,
  <>
   Beneficiaries are supported <br></br> with dignity and respect.
  </>,
  <>
   Confidentiality is upheld <br></br> at all times.
  </>,
  <>
    Records are reviewed periodically <br></br> for accountability.
  </>,
  <>
    Support may include both financial <br></br> aid and emotional guidance.
  </>,
  <>
 Every act of support reflects <br></br> the living spirit of  <br></br> I Am Peacekeeper.
  </>
];

const circleCourses = [
  {
    text: (
      <>
        Together, we uphold one another in times of need.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        No I Am Peacekeeper should face hardship alone.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Contribute to the Welfare Fund and extend your hand of care
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Be the heart of Justice, Love & Peace in someone’s life.
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard" style={{padding:"14px"}}>
     <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {description}
    </Typography>
  </Paper>
);

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);


const RegisterYourselfCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`gradientCard ${colorClass}`}
    sx={{
      width: 130,
      height: 130,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const WelfareFund = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Registration Hero Background Section */}
      <Box
        className="programRegistrationSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
         
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Registration Main Section */}
      <Box className="" mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
              I Am Peacekeeper 
                Welfare Fund
            </Typography>
          </Grid>
        </Grid>
      </Box>

                 {/* Top Section UI */}
       <Box className="schoolProgramMainSection topBlockBox" mt={5}>
               {/* <Typography
                          variant="h5"
                          align="center"
                          fontWeight="bold"
                          gutterBottom
                          className="subHeading"
                          pt={5}
                        >
                         TOP
                        </Typography> */}
                 <Container className="paddingContainer" sx={{fontFamily:"var(--default-font)"}}>
                <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                  {highlights.map((item, index) => (
                   <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                                    <BlockCard title={item.title}
                                     description={item.description}
                                     colorClass={item.colorClass}
                                     image={item.image} 
                                                     />
                                                  </Grid>
                  ))}
                </Grid>
              </Container>
              </Box>

              {/* why it matters */}
                <Box mt={5} className="programCardMain corporateMainSection mt-50px">
                                <Typography
                                  variant="h2"
                                  align="center"
                                  fontWeight={400}
                                  gutterBottom
                                  className="subHeading mb-0px"
                                  sx={{ fontFamily: 'var(--heading-font)' }}
                                >
                                  Why It Matters
                                </Typography>
                                {/* <p align="center">
                                  Your organization’s partnership directly supports your Corporate
                                  Social <br></br> Responsibility (CSR) goals
                                </p> */}
                      
                                <Container className="paddingSubContainer programCardContainer mt-30px">
                                  <Grid
                                    container
                                    spacing={2}
                                    mt={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    display="flex"
                                  >
                                    {whyItMatters.map((text, index) => (
                                      <Grid
                                        size={{ xs: 12, md: 3, sm: 4 }}
                                        key={index}
                                        justifyContent="center"
                                        alignItems="center"
                                        display="flex"
                                      >
                                        <ProgramCard text={text} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                              </Box>
                {/* How It Works */}
                               <Box className="schoolProgramMainSection">
                                  <Typography
                                         variant="h2"
                                         align="center"
                                         fontWeight={400}
                                         gutterBottom
                                         mt={5}
                                         className="subHeading mt-50px"
                                         sx={{ fontFamily: 'var(--heading-font)' }}
                                       >
                                        How It Works
                                       </Typography>
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                                           {howITWorks.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                               </Box>  

                               {/* closing */}
                                <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'70px'
                                                        }}
                                                        mt={5}
                                                        className="">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                        >
                                                        Our Strategic Considerations
                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5}>
                                                          <Grid container spacing={5} justifyContent="center" mb={4}>
                                                            {circleCourses.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                                 </Box>     

  {/* Register –  Yourself, Your Friend */}
      <Box className="registerSection d-none" mt={3}>
        <Typography className="registerHeading">
          Register – <br></br>
          Yourself, Your Friends
        </Typography>

        <Box className="campusPeaceSection">
          <Container className="paddingContainer mt-50px max-width-800px">
            <Grid container spacing={0} justifyContent="center" mb={4}>
              {registerYourself.map(({ text, colorClass }, index) => (
                <Grid size={{ xs: 12, md: 3, sm: 3 }} key={index}>
                  <RegisterYourselfCard text={text} colorClass={colorClass} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>
      {/* Last section */}

      <Box mt={5} className="d-none">
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            className="d-flex-align-center-justify-center flex-direction-column w-100"
          >
            <Typography
              variant="h5"
              align="center"
              fontWeight="bold"
              gutterBottom
              className="subHeading mb-0px subText"
            >
              Easy registration + friend referrals build
              <br></br>a Global network.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default WelfareFund;
